import React, { useEffect, useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BASE_API_URL from '../../../apis/index';
import axios from 'axios';
import { Button } from '@mui/material';
import styled from 'styled-components';

export default function CompServicesSection({ compId, compName, compTypes, userId }) {
    const [service, setService] = useState(null);

    useEffect(() => {
        async function fetchServices() {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_API_URL}/api/admin/company/services/${compId}`, {
                    // params: { company_id: compId },
                    headers: { Authorization: `Bearer ${authToken}` },
                });

                setService(res.data || null);
            } catch (err) {
                console.error("Failed to fetch services", err);
            }
        }
        fetchServices();
    }, [compId]);

    if (!service) {
        return (
            <div className='py-md-5 p-4 bg-light my-4 rounded-4 d-flex align-items-center justify-content-between pb-3 border-bottom'>
                <h4 className='fw-normal txt_color_primary'> Services - Contract Manufacturer Organisation </h4>
            </div>
        )
    }

    return (
        <CompServicesSectionWrapper className="py-md-5 p-5 rounded-5 bg-light my-5">
            <div className="border rounded-4 overflow-hidden">
                <h5 className="txt_color_primary fw-medium px-3 py-4 bg-light border-bottom">Services - Contract Manufacturer Organisation:</h5>
                <div className="w-100">
                    <div className='d-flex align-items-center'>
                        <div className='w-25 bg-white p-3'>Dosage Formats:</div>
                        <div className='w-75 p-2 d-flex flex-wrap gap-2'>
                            {JSON.parse(service.dosage_formats || "[]").map((item, i) => (
                                <div className="Pill" key={i}>{item}</div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="w-100 border-top">
                    <div className='d-flex align-items-center'>
                        <div className='w-25 bg-white p-3'>Specialities:</div>
                        <div className='w-75 p-2 d-flex flex-wrap gap-2'>
                            {JSON.parse(service.specialities || "[]").map((item, i) => (
                                <div className="Pill" key={i}>{item}</div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="w-100 border-top">
                    <div className='d-flex align-items-center'>
                        <div className='w-25 bg-white p-3'>Capabilities:</div>
                        <div className='w-75 p-2 d-flex flex-wrap gap-2'>
                            {JSON.parse(service.capabilities || "[]").map((item, i) => (
                                <div className="Pill" key={i}>{item}</div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="w-100 border-top">
                    <div className='d-flex align-items-center'>
                        <div className='w-25 bg-white p-3'>Packaging:</div>
                        <div className='w-75 p-2 d-flex flex-wrap gap-2'>
                            {JSON.parse(service.packaging || "[]").map((item, i) => (
                                <div className="Pill" key={i}>{item}</div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="w-100 border-top">
                    <div className='d-flex align-items-center'>
                        <div className='w-25 bg-white p-3'>Supporting Documents:</div>
                        <div className='w-75 p-2 d-flex flex-wrap gap-2'>
                            {JSON.parse(service.document_names || "[]").length > 0 && JSON.parse(service.document_names || "[]").map((item, i) => {
                                const fileUrl = `${BASE_API_URL}/uploads/user_srvc_docs/${JSON.parse(service.supporting_documents)[i]}`;
                                return (
                                    <Button key={i} variant="outlined" color="warning" startIcon={<PictureAsPdfIcon />} href={fileUrl} target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '5px',
                                            padding: '5px 12px',
                                            fontSize: '14px',
                                        }}
                                    >
                                        {item}
                                    </Button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </CompServicesSectionWrapper>
    );
};

const CompServicesSectionWrapper = styled.div`
  .carousel-img {
    width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 10px;
  }
  .PillContainer{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .Pill{
    background: white;
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 14px;
    border: 1px solid #ffffffff;
  }
`;
